<template>
    <div class="m-onboard">

        <!-- First Login / Horizontal Onboarding -->
        <v-card class="start-fullscreen-onboarding pa-7" id="startFullOnboarding" v-if="item.status = 'view'">
            <v-window v-model="current">
                <v-window-item :key="`m-onboard-item-${index}`" lazy v-for="(item, index) in steps">
                    <slot :index="index" :item="item" name="template"/>
                </v-window-item>
            </v-window>


            <!-- Start fullscreen Onboarding -->
            <v-layout>
                <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="dialog">
                    <template v-slot:activator="{ on }">
                        <v-layout wrap v-if="item.name == 'first_steps'">
                            <v-flex xs12 md7>
                                <e-button-secondary class="m-onboard__btn-start-onboard" v-on="on">{{$t('modules.onboards.start-onboard.start')}}</e-button-secondary>
                            </v-flex>
                            <v-flex xs12 md5 class="m-onboard__btn-skip">
                                <e-typography-bold @click="close" tabindex="0">{{$t('modules.onboards.start-onboard.not-show-again')}}</e-typography-bold>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap v-if="item.name != 'first_steps'">
                            <v-flex xs12 md12 mr-4 class="m-onboard__btn-skip m-onboard__btn-skip-right">
                                <e-typography-bold @click="close" tabindex="0">{{$t('modules.onboards.start-onboard.not-show-again')}}</e-typography-bold>
                            </v-flex>
                        </v-layout>
                    </template>
                    <v-card>
                        <v-subheader color="primary">
                            <div class="logo-container">
                                <m-block-nav-logo :drawer="logoDrawer"/>
                            </div>
                            <v-btn @click="dialog = false" dark icon>
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-subheader>
                        <m-onboard-step-info @skip="skip"/>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-card>

<!--         First Steps / Vertical Onboarding-->
        <div class="fullscreen" v-if="this.$route.name.match(/^dashboard\-onboarding.*/)">
            <m-onboard-header @next="next" :current="current" :steps="steps"/>
            <v-card class="pa-3 container fullscreen__container">
                <v-window v-model="current" v-if="!isRiskAssessment">
                    <v-window-item :key="`m-onboard-item-${index}`" lazy v-for="(item, index) in steps">
                        <slot :index="index" :item="item" name="template"/>
                        <MOnboardStepEmployee @next="next" v-if="index == 0"/>
                        <MOnboardStepObjects @next="next" @setObjectId="setObjectId" v-if="index == 1"/>
                        <MOnboardStepRa @next="next" :objectId="selectedObjectId" v-if="index == 2"/>
                    </v-window-item>
                </v-window>
                <div v-else-if="isRiskAssessment">
                   <MOnboardRiskAssessment :item="item" />
                </div>
            </v-card>
        </div>

    </div>
</template>

<script>
    import MOnboardStepEmployee from "@modules/onboards/steps/m-onboard-step-employee";
    import MOnboardStepObjects from "./steps/m-onboard-step-objects";
    import MOnboardStepRa from "@modules/onboards/steps/m-onboard-step-ra";
    import MOnboardRiskAssessment from "@modules/onboards/m-onboard-riskassessment"
    import MOnboardStepper from "@modules/onboards/concrete/m-onboard-stepper";
    import {mapActions} from 'vuex';
    import objects from "../../../store/modules/objects";
    import MBlockNavLogo from "@modules/blocks/header/m-block-nav-logo";
    import MOnboardStepInfo from "./steps/m-onboard-step-info";
    import MOnboardHeader from "./concrete/m-onboard-header";

    export default {
        name: "m-onboard",
        data: () => ({
            current: 0,
            selectedObjectId: '',
            logoDrawer: true,
            dialog: false
        }),
        components: {
            MOnboardHeader,
            MOnboardStepInfo,
            MOnboardStepEmployee,
            MOnboardStepObjects,
            MOnboardStepRa,
            MOnboardStepper,
            MBlockNavLogo,
            MOnboardRiskAssessment
        },
        props: {
            item: {
                type: Object,
                required: true
            },
            arrows: {
                type: Boolean,
                default: false
            },
            isRiskAssessment: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            item() {
                this.current = 0
            }
        },
        computed: {
            steps() {
                if (this.$lodash.isEmpty(this.item.steps)) {
                    return []
                }

                return this.item.steps;
            },

            isLast() {
                return (this.current + 1) === this.steps.length;
            },
            isFirstLogin() {
                return !!this.$user.attributes.isFirstLogin
            },
            saveCurrent() {
                return {
                    _id: this.$user.id.split('/')[2],
                    onBoarding: [{
                        currentStep: this.current
                    }]
                }
            }
        },
        methods: {
            ...mapActions({
                requestUpdateUser: 'users/update',
            }),
            setObjectId(id) {
                this.selectedObjectId = id;
                this.next();
            },
            updateCurrent() {
                this.requestUpdateUser(this.saveCurrent)
            },
            next() {
                if (this.current + 1 !== this.steps.length) this.current++;
            },

            prev() {
                this.current = this.current - 1 < 0 ? 0 : this.current - 1
            },

            more() {
                this.next();
            },

            skip() {
                this.$emit('skip')
            },

            close() {
                this.$emit('dismiss', this.item)
                document.getElementById("startFullOnboarding").style.display = "none";
            },
            reloadPage() {
                setTimeout(() => {
                    location.reload();
                }, 500);
            }
        }
    }
</script>

<style lang="scss">
    .v-window__container--is-active {
        height: auto !important;
    }

    .v-window-item {

        p:last-of-type {
            margin-bottom: 0;
        }
    }

    .logo-container {
        position: fixed;
        left: 8vw;

        @include media(md) {
            position: relative;
            left: 1vw;
        }
    }

    .m-onboard-step-buttons-wrap {
        display: none;
    }


    .m-onboard-header-buttons,
    .m-onboard-step-buttons {
        display: flex;
        align-items: center;
    }

    .v-dialog--fullscreen {
        .v-subheader {
            display: flex;
            height: 11vh;
            width: 100%;
            background: var(--v-primary-base);
            z-index: 99;

            .v-btn {
                position: fixed;
                right: 8vw;
                top: 1.3rem;

                @include media(md) {
                    position: absolute;
                    right: 1vw;
                    top: 1vw;
                }
            }
            @include media(md) {
                position: relative;
            }
        }
    }

    .m-onboard {
        .v-subheader {
            position: fixed;
            width: 100%;
            height: 7rem;
            background: var(--v-primary-base);
            z-index: 90;

            @include media(md) {
                height: 6rem;
            }
        }

        .start-fullscreen-onboarding {
            margin-top: 1rem;
            background: var(--v-primary-base);
            border-radius: 3px !important;

            .e-typography-heading-1, .e-typography-body-small {
                color: var(--v-white);
            }
        }
        &__btn-skip-right {
            text-align: right;
            padding-right: 2rem !important;

            @include updatedMedia(sm) {
                padding-right: 0 !important;
            }
        }
        &__btn-skip {
            justify-content: flex-end;
            display: flex;
            padding-top: 1.7rem !important;
            padding-bottom: 1.7rem !important;
            padding-right: 1.7rem !important;

            @include media(md) {
                padding-bottom: 0 !important;
                padding-right: 0 !important;
            }
            @media screen and (max-device-aspect-ratio: 16/9) {
                justify-content: flex-end;
                display: flex;
                padding-right: 1.5rem !important;
            }
            .e-typography-bold {
                cursor: pointer;
                font-size: 1.1rem;
                color: var(--v-white);

                &:hover {
                    text-decoration: underline;
                }
                @include updatedMedia(sm) {
                    display: block;
                    padding-left: .7rem;
                    padding-top: 1rem;
                }
            }
        }
        &__btn-start-onboard {
            @include media(md) {
                display: inline-block;
                margin: 0 auto !important;
                width: 95%;
            }
        }

        .v-card {
            &__title {
                padding: 0;

                .e-typography-heading-1 {
                    padding: 0 0 1rem 0;
                }
            }

            &__text {
                padding-bottom: 1.5rem !important;
            }

            &__actions {
                justify-content: space-between;

                .v-btn.e-button {
                    width: auto;
                }
            }
        }

        .fullscreen {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100%;
            min-height: 100vh;
            z-index: 99;
            background: var(--v-secondary-base);
            overflow: scroll;

            &__container {
                margin-top: 11rem;
                margin-bottom: 5rem;
                background: var(--v-secondary-base);
                box-shadow: none;

                @include media(md) {
                    margin-top: 1rem;
                }
            }
            @include media (md) {
                top: 4rem;
            }
        }

        .e-link-item {
            padding: 8px 0;
        }

        &__bullets {
            width: 100%;
            border-top: 2px solid var(--v-secondary-base);
            padding: 2px 0 54px 0;
        }

        &__button {
            &_next,
            &_prev {
                position: absolute;
                top: 50%;
                transform: translate(0, -50%);

                /deep/ i {
                    font-size: 2rem;
                }
            }

            &_next {
                right: -56px;
            }

            &_prev {
                left: -56px;
            }
        }

        @include media(sm) {
            .layout {
                display: block;
            }
        }
    }
</style>
